import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid",
  style: {"padding-top":"130px"}
}
const _hoisted_2 = { class: "navbar fixed-bottom navbar-dark bg-dark d-flex justify-content-center" }
const _hoisted_3 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_4 = {
  class: "container-fluid",
  style: {"padding-top":"130px"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "mx-5" }
const _hoisted_8 = { class: "text-dark" }
const _hoisted_9 = {
  class: "my-0 mx-5",
  style: {"font-size":"2em","font-weight":"300","color":"#33475b"}
}
const _hoisted_10 = { class: "col-6 col-lg-5 text-right col align-self-end" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "btn-group" }
const _hoisted_13 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "btn-group mr-1" }
const _hoisted_16 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_17 = { class: "btn-group mr-1" }
const _hoisted_18 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_19 = { class: "btn-group" }
const _hoisted_20 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  class: "col-lg-3 col-md-3 col-sm-4 col-xs-12",
  style: {"padding-bottom":"100px"}
}
const _hoisted_23 = { class: "card" }
const _hoisted_24 = { class: "card-header" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "dropdown" }
const _hoisted_27 = {
  class: "h5 dropdown-toggle",
  "data-toggle": "dropdown",
  style: {"white-space":"normal"}
}
const _hoisted_28 = {
  class: "dropdown-menu",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_29 = { class: "input-group px-3 mb-1" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "list-group mt-2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  class: "col-lg-7 offset-lg-1 col-md-9 col-sm-8 col-xs-12",
  style: {"padding-bottom":"100px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriteriaSurveyAccessLinks = _resolveComponent("CriteriaSurveyAccessLinks")!
  const _component_CriteriaSurveyEmailSender = _resolveComponent("CriteriaSurveyEmailSender")!
  const _component_CriterionDetailsDialog = _resolveComponent("CriterionDetailsDialog")!
  const _component_MeetingStarterDialog = _resolveComponent("MeetingStarterDialog")!
  const _component_MeetingStopperDialog = _resolveComponent("MeetingStopperDialog")!
  const _component_DisagreementsReportDialog = _resolveComponent("DisagreementsReportDialog")!
  const _component_PanelConsistencyAnalysisDialog = _resolveComponent("PanelConsistencyAnalysisDialog")!
  const _component_SurveyOpenerDialog = _resolveComponent("SurveyOpenerDialog")!
  const _component_SurveyCloserDialog = _resolveComponent("SurveyCloserDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_MeetingQuestionReview = _resolveComponent("MeetingQuestionReview")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriteriaSurveyAccessLinks, {
      viewModel: _ctx.criteriaSurveyAccessLinks,
      onShowEmailSender: _ctx.showCriteriaSurveyEmailSender,
      onDownloadLinks: _ctx.handleDownloadAccessLinks
    }, null, 8 /* PROPS */, ["viewModel", "onShowEmailSender", "onDownloadLinks"]),
    _createVNode(_component_CriteriaSurveyEmailSender, {
      viewModel: _ctx.criteriaSurveyEmailSender,
      onSendEmail: _ctx.handleSendEmailCommand
    }, null, 8 /* PROPS */, ["viewModel", "onSendEmail"]),
    _createVNode(_component_CriterionDetailsDialog, { viewModel: _ctx.criterionDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_MeetingStarterDialog, {
      propOpened: _ctx.meetingStarterOpened,
      propSurveyStarted: _ctx.SurveyStarted,
      propAutoRevealEnabled: _ctx.AutoRevealEnabled,
      propNamesRevealed: _ctx.NamesRevealed,
      onStartMeeting: _ctx.handleStartMeetingCommand,
      onStartSurvey: _ctx.handleStartSurveyCommand,
      onStopSurvey: _ctx.handleStopSurveyCommand,
      onToggleAutoReveal: _ctx.ToggleAutoRevealCommand,
      onToggleNamesRevealed: _ctx.ToggleNamesRevealedCommand,
      onShowAccessLinks: _ctx.ShowAccessLinksCommand,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.meetingStarterOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propSurveyStarted", "propAutoRevealEnabled", "propNamesRevealed", "onStartMeeting", "onStartSurvey", "onStopSurvey", "onToggleAutoReveal", "onToggleNamesRevealed", "onShowAccessLinks"]),
    _createVNode(_component_MeetingStopperDialog, {
      propOpened: _ctx.meetingStopperOpened,
      propSurveyStarted: _ctx.SurveyStarted,
      onStopMeeting: _ctx.handleStopMeetingCommand,
      onStartSurvey: _ctx.handleStartSurveyCommand,
      onStopSurvey: _ctx.handleStopSurveyCommand,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.meetingStopperOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propSurveyStarted", "onStopMeeting", "onStartSurvey", "onStopSurvey"]),
    _createVNode(_component_DisagreementsReportDialog, {
      propOpened: _ctx.disagreementsReportOpened,
      propRm: _ctx.disagreementReport,
      onShowQuestion: _ctx.handleShowDisagreementsQuestion,
      onCloseDialog: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disagreementsReportOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propRm", "onShowQuestion"]),
    _createVNode(_component_PanelConsistencyAnalysisDialog, {
      propOpened: _ctx.consistencyAnalysisOpened,
      propRm: _ctx.consistencyAnalysis,
      onShowQuestion: _ctx.handleShowInconsistentQuestion,
      onCloseDialog: _cache[3] || (_cache[3] = ($event: any) => (_ctx.consistencyAnalysisOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propRm", "onShowQuestion"]),
    _createVNode(_component_SurveyOpenerDialog, {
      propOpened: _ctx.surveyOpenerOpened,
      propSurveyId: _ctx.surveyId,
      onStartSurvey: _ctx.handleStartSurveyCommand,
      onShowAccessLinks: _ctx.ShowAccessLinksCommand,
      onCloseDialog: _cache[4] || (_cache[4] = ($event: any) => (_ctx.surveyOpenerOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propSurveyId", "onStartSurvey", "onShowAccessLinks"]),
    _createVNode(_component_SurveyCloserDialog, {
      propOpened: _ctx.surveyCloserOpened,
      propSurveyId: _ctx.surveyId,
      onStopSurvey: _ctx.handleStopSurveyCommand,
      onCloseDialog: _cache[5] || (_cache[5] = ($event: any) => (_ctx.surveyCloserOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propSurveyId", "onStopSurvey"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    (_ctx.initialized === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[26] || (_cache[26] = [
          _createElementVNode("h3", null, [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }),
            _createTextVNode(" Loading...")
          ], -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.initialized)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("nav", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.PreviousQuestionCommand && _ctx.PreviousQuestionCommand(...args))),
                type: "button",
                class: "btn btn-secondary"
              }, [...(_cache[27] || (_cache[27] = [
                _createElementVNode("i", {
                  class: "fa fa-chevron-left",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */),
                _createTextVNode(),
                _createElementVNode("span", null, "Prev question", -1 /* CACHED */)
              ]))]),
              (_ctx.AllQuestionsAnswered === false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.NextUnansweredQuestionCommand && _ctx.NextUnansweredQuestionCommand(...args))),
                    type: "button",
                    class: "btn btn-warning",
                    title: "Go to next unanswered question"
                  }, " Next unanswered "))
                : _createCommentVNode("v-if", true),
              (_ctx.AllQuestionsAnswered === true)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.AllDoneCommand && _ctx.AllDoneCommand(...args))),
                    type: "button",
                    class: "btn btn-success",
                    title: "Go to next unanswered question"
                  }, " All done "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.NextQuestionCommand && _ctx.NextQuestionCommand(...args))),
                type: "button",
                class: "btn btn-secondary"
              }, [...(_cache[28] || (_cache[28] = [
                _createElementVNode("span", null, "Next question", -1 /* CACHED */),
                _createTextVNode(),
                _createElementVNode("i", {
                  class: "fa fa-chevron-right",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h6", _hoisted_7, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, [...(_cache[29] || (_cache[29] = [
                    _createElementVNode("i", {
                      class: "fa fa-angle-double-left",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */),
                    _createTextVNode(" Back to weights ", -1 /* CACHED */)
                  ]))])), [
                    [_directive_sanitizedHref, _ctx.url_Criteria_WeightsPage]
                  ])
                ]),
                _createElementVNode("h1", _hoisted_9, "Panel: " + _toDisplayString(_ctx.Name), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.MeetingStarted === false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success mr-1",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showMeetingStarterCommand && _ctx.showMeetingStarterCommand(...args)))
                      }, "Start Meeting"),
                      (_ctx.SurveyStarted === false)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-outline-secondary mr-1",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.surveyOpenerOpened = true))
                          }, "Open Survey"))
                        : _createCommentVNode("v-if", true),
                      (_ctx.SurveyStarted === true)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-outline-secondary mr-1",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.surveyCloserOpened = true))
                          }, "Close Survey"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary mr-1",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.ShowAccessLinksCommand && _ctx.ShowAccessLinksCommand(...args)))
                      }, " Access links "),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[30] || (_cache[30] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Analyze votes ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showDisagreementsReport && _ctx.showDisagreementsReport(...args)))
                          }, "Disagreements"),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.showConsistencyAnalysis && _ctx.showConsistencyAnalysis(...args)))
                          }, "Consistency")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.MeetingStarted === true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-warning",
                          onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.ToggleVotesRevealedCommand && _ctx.ToggleVotesRevealedCommand(...args)))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(_ctx.VotesRevealed === true ? 'fa-regular fa-fw fa-square-check' : 'fa-regular fa-fw fa-square')
                          }, null, 2 /* CLASS */),
                          _cache[31] || (_cache[31] = _createTextVNode(" Reveal votes ", -1 /* CACHED */))
                        ]),
                        _cache[34] || (_cache[34] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-warning dropdown-toggle dropdown-toggle-split",
                          "data-toggle": "dropdown"
                        }, null, -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("a", {
                            class: "dropdown-item px-1",
                            onClick: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ToggleAutoRevealCommand && _ctx.ToggleAutoRevealCommand(...args)), ["stop"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.AutoRevealEnabled === true ? 'fa-regular fa-fw fa-square-check' : 'fa-regular fa-fw fa-square')
                            }, null, 2 /* CLASS */),
                            _cache[32] || (_cache[32] = _createTextVNode(" Auto reveal ", -1 /* CACHED */))
                          ]),
                          _createElementVNode("a", {
                            class: "dropdown-item px-1",
                            onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ToggleNamesRevealedCommand && _ctx.ToggleNamesRevealedCommand(...args)), ["stop"]))
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.NamesRevealed === false ? 'fa-regular fa-fw fa-square-check' : 'fa-regular fa-fw fa-square')
                            }, null, 2 /* CLASS */),
                            _cache[33] || (_cache[33] = _createTextVNode(" Anonymous ", -1 /* CACHED */))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[35] || (_cache[35] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Analyze votes ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.showDisagreementsReport && _ctx.showDisagreementsReport(...args)))
                          }, "Disagreements"),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.showConsistencyAnalysis && _ctx.showConsistencyAnalysis(...args)))
                          }, "Consistency")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[37] || (_cache[37] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.meetingStopperOpened = true))
                          }, "Stop Meeting"),
                          _cache[36] || (_cache[36] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          (_ctx.SurveyStarted === false)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "dropdown-item",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.surveyOpenerOpened = true))
                              }, "Open Survey"))
                            : _createCommentVNode("v-if", true),
                          (_ctx.SurveyStarted === true)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "dropdown-item",
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.surveyCloserOpened = true))
                              }, "Close Survey"))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.ShowAccessLinksCommand && _ctx.ShowAccessLinksCommand(...args)))
                          }, "Access links")
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _cache[41] || (_cache[41] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[38] || (_cache[38] = _createTextVNode(" Questions ", -1 /* CACHED */)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.AnsweredQuestionsCount) + "/" + _toDisplayString(_ctx.QuestionsCount), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("a", _hoisted_27, _toDisplayString(_ctx.CurrentContext?.Name), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _withDirectives(_createElementVNode("input", {
                            type: "search",
                            placeholder: "Search...",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, _ctx.SearchPhrase]
                          ]),
                          _cache[39] || (_cache[39] = _createElementVNode("span", { class: "input-group-append" }, [
                            _createElementVNode("span", { class: "input-group-text" }, [
                              _createElementVNode("i", {
                                class: "fa-solid fa-magnifying-glass",
                                "aria-hidden": "true"
                              })
                            ])
                          ], -1 /* CACHED */))
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EvalContextsView, (c) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.SetCurrentContext(c.CriterionId)),
                            key: c.CriterionId
                          }, [
                            _createTextVNode(_toDisplayString(c.Name), 1 /* TEXT */),
                            _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                            _createElementVNode("small", null, _toDisplayString(c.Path), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_30))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.QuestionsView, (q) => {
                        return (_openBlock(), _createElementBlock("a", {
                          class: _normalizeClass(["list-group-item list-group-item-action", {'bg-secondary text-white': _ctx.CurrentQuestionId === q.QuestionId}]),
                          key: q.QuestionId,
                          onClick: ($event: any) => (_ctx.SwitchQuestion(q.QuestionId))
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(_ctx.getQuestionCssClass(q))
                          }, null, 2 /* CLASS */),
                          _createTextVNode(" " + _toDisplayString(q.FirstCriterionName) + " vs. " + _toDisplayString(q.SecondCriterionName), 1 /* TEXT */)
                        ], 10 /* CLASS, PROPS */, _hoisted_32))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_MeetingQuestionReview, {
                  readModel: _ctx.Question,
                  onShowCriterionDetails: _ctx.showCriterionDetails,
                  onUpdateValue: _ctx.handleSavePanelVoteCommand,
                  onUpdateComment: _ctx.handleSavePanelVoteCommentCommand
                }, null, 8 /* PROPS */, ["readModel", "onShowCriterionDetails", "onUpdateValue", "onUpdateComment"])
              ])
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}